/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IRemessaZipDownloadRepository } from "@/repositories/remessas/types";

const remessaDownloadZipRepository: IRemessaZipDownloadRepository = {
  /**
   * Função para fazer download de qualquer tipo de arquivo da remessa (ZIP, CSV, PDF)
   */
  async getDownloadZipRemessa<T>(
    accessToken: string,
    remessa_id: number,
    numero_remessa: number
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const response = await Instance.get(`remessas/${remessa_id}/fotos/download`, {
      responseType: "blob",
      headers: {
        Accept: "application/zip",
      },
    });

    // cria um blob e força o download no navegador
    const blob = new Blob([response.data], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${numero_remessa}.zip`;
    document.body.appendChild(link);
    link.click();

    // limpa referências
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return null;
  },
};

/**
 * EXPORTS
 */
export { remessaDownloadZipRepository };
